import { Typography } from '@mui/material';
import * as React from 'react';
import { CONST_BUSINESS_NAME } from './Helper';

export default function Copyright(props) {

  return (
    <Typography variant="body2" color="#fff" align="center" {...props} style={{
      textWrap: 'wrap'
    }}>
      &copy;{new Date().getFullYear()}
      {' '}
      {CONST_BUSINESS_NAME} All Rights Reserved.
    </Typography>
  );
}